import { Text } from "@fluentui/react-components";
import { ErrorCircle12Filled } from "@fluentui/react-icons";
import styled from "styled-components";

export const ErrorText = styled(Text)`
    color: ${(props) => props.theme. serviceDeskNotesErrors};
`;

export const ErrorIcon = styled(ErrorCircle12Filled)`
    color: ${(props) => props.theme. serviceDeskNotesErrors};
`;

export const ErrorMessageWrapper = styled.span`
    @media (max-width: 710px) {
        margin-left: 30px;
    }
`;